import { setDefaultProvider } from '@sats-connect/core';

import { WalletType } from '@/context/types';
import { WALLET_CONNECTOR, WalletConnector } from './connector';
import { UNISAT_CONNECTOR } from './connector-unisat';

export function parse_error(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  } else if (typeof err === 'string') {
    return err;
  } else {
    return String(err);
  }
}

export function hexToBase64(hex: string): string {
  // Convert hex string to a Buffer
  const buffer = Buffer.from(hex, 'hex');
  // Convert the Buffer to a Base64 string
  return buffer.toString('base64');
}

export function getWalletConnector(walletType: WalletType): WalletConnector {
  // console.log(`[getWalletConnector] for ${walletType}`)
  if (walletType && !Object.values(WalletType).includes(walletType)) {
    console.error(
      `Unexpected wallet type! ${walletType}. Expected: [${Object.values(WalletType).join(', ')}]`
    );
  }
  switch (walletType) {
    case WalletType.Xverse:
      // Note: to avoid sats-connect UI set the default provider manually.
      setDefaultProvider('XverseProviders.BitcoinProvider');
      return WALLET_CONNECTOR;
    case WalletType.Unisat:
      return UNISAT_CONNECTOR;
  }
}

export async function wait(ms: number) {
  await new Promise((resolve) => setTimeout(resolve, ms));
}

export function getMinNotZero(a: number, b: number, c: number) {
  if (a && a < b && a < c){
    return a;
  }
  return Math.min(b, c);
}
